import { render, staticRenderFns } from "./dashboard-admin.vue?vue&type=template&id=77318403&scoped=true"
import script from "./dashboard-admin.vue?vue&type=script&lang=js"
export * from "./dashboard-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77318403",
  null
  
)

export default component.exports